import ParkIcon from '@mui/icons-material/Park';
import { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const MerkleTreeIcon = (props: SvgIconProps) => <ParkIcon {...props} />;
export default MerkleTreeIcon;
